// Dropdown variants: trigger input + popover panel + option rows, resolved by part.
export const DROPDOWN_VARIANTS = Object.freeze(["filterDropdown"]);

export const DROPDOWN_PARTS = Object.freeze(["trigger", "panel", "option", "optionSelected", "tick", "tickSelected", "rangeSlider", "rangeValueBox", "popper"]);

export const DROPDOWN_USE_CASES = Object.freeze({
  filterDropdown:
    "Filter-row dropdowns — trigger per filterDropDown-recipe.md; multiselect panel/options/tick per filtermultiSelectDropDownOptions.md (colours inferred from the AgriInput frame, not specified).",
});
